export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const GET_SERVICE_ELIGIBILITY_SUCCESS = 'GET_SERVICE_ELIGIBILITY_SUCCESS'
export const GET_SERVICE_ELIGIBILITY_FAILURE = 'GET_SERVICE_ELIGIBILITY_FAILURE'



// WEBPACK FOOTER //
// ./services/app-state/profile/constants/index.js